export type TMessageType = 'mass_creative_create' | 'screenshot' | 'mark_url_get';

export type TMessageStatuses = 'ERROR' | 'SUCCESS';

export type TMessage = IMassCreativeCreateMessage | IScreenshotMessage | IMsrkMessage;

export interface IMassCreativeCreateMessage {
  campaign_xxhash: string;
  campaign_internal_id: string;
  campaign_title: string;
  task_id: number;
  status: TMessageStatuses;
}

export interface IScreenshotMessage {
  creative_xxhash: string;
  creative_internal_id: string;
  creative_title: string;
  campaign_xxhash: string;
  status: TMessageStatuses;
  screenshot_url?: string;
  error_code?: number;
  error_message?: string;
}

export interface IMsrkMessage {
  creative_xxhash: string;
  creative_internal_id: string;
  creative_title: string;
  campaign_xxhash: string;
  status: TMessageStatuses;
}

export interface NotificationMessage {
  notification_id: number;
  title: string;
  message: TMessage;
  date: string;
  type: TMessageType;
  is_read: boolean;
}

export type NotificationMessages = NotificationMessage[];

export function isScreenshotMessage(message: TMessage): message is IScreenshotMessage {
  return message && 'creative_xxhash' in message && 'creative_title' in message && 'creative_title' in message;
}

export function isMassCreativeCreateMessage(message: TMessage): message is IMassCreativeCreateMessage {
  return message && 'campaign_xxhash' in message && 'campaign_title' in message && 'campaign_title' in message;
}

export const isMarkMessage = (
  message: TMessage
): message is IScreenshotMessage | IMsrkMessage => (
    'creative_internal_id' in message &&
    'campaign_xxhash' in message &&
    'creative_title' in message
  );